import { defineStore } from "pinia";
import { WeatherApi } from "@/api";
import { ref } from "vue";

export const useWeatherStore = defineStore("weather", () => {
  const weather = ref(null);
  const loading = ref(false);
  const error = ref(null);

  async function fetchWeather() {
    loading.value = true;
    try {
      const { data } = await WeatherApi.getWeather();
      weather.value = data;
    } catch (err) {
      console.error("Ошибка при получении данных о погоде:", err);
      error.value = err;
    } finally {
      loading.value = false;
    }
  }

  return {
    weather,
    loading,
    error,

    fetchWeather,
  };
});
